"use client";

import { useEffect, useRef, type MutableRefObject } from "react";

export interface UseTimelinePeriodRefsInput {
  periodCount: number;
}

export function useTimelinePeriodRefs({
  periodCount,
}: UseTimelinePeriodRefsInput): MutableRefObject<Array<HTMLDivElement | null>> {
  const periodRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    periodRefs.current = periodRefs.current.slice(0, periodCount);
  }, [periodCount]);

  return periodRefs;
}
